import { OAuthModuleConfig } from 'angular-oauth2-oidc';

export const identityModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: [
      'http://localhost:5000/api', 
      'https://localhost:5001/api', 
      'http://localhost:5050/api', 
      'https://app.charla.com/api',
      'https://app-dev.charla.com/api'
    ],
    sendAccessToken: true,
  }
};